// extracted by css-extract-rspack-plugin
export default {"tabButton":"L3Seow","tab":"sVOeVi","small":"_XH9PA","wrapper":"q3lp4e","tag":"SAx3Jv","active":"Y1Rftr"};